module.exports = __webpack_public_path__ + "15aad891edf2bfb937cf5f35acc4243b.jpg";